<template>
  
  <div class="scroll-section">
    <slot></slot>
  </div>

</template>
<script>
export default {
  name: "scroll-section",
  props: {
    idindex: {
      type: Number,
      default: 0,
    },
    idname: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: true,
    },
    ishidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scroll_tracker: null,
    }
  },
  watch: {
    show(value){
        if(this.scroll_tracker) {
          if(this.ishidden == false && this.idname == "applicant-"+this.idindex+"-capture-section-addresses-previous-new") {
            this.scroll_tracker.setSectionShown(this, false);
          } else { 
            this.scroll_tracker.setSectionShown(this, value);
          }
        }
    },
  },
  mounted(){
    let scroll_tracker = this;
    while(scroll_tracker && scroll_tracker.$options.name != 'scroll-tracker'){
      scroll_tracker = scroll_tracker.$parent;
    }
    if(scroll_tracker){
      this.scroll_tracker = scroll_tracker;
      this.scroll_tracker.addSection(this);
     }else{
      console.error('ScrollSection unable to find ScrollTracker parent', this);
    }
  },
  beforeDestroy(){
   if(this.scroll_tracker)
      this.scroll_tracker.removeSection(this);
 
   const scrollsectionsin = this.scroll_tracker.sections;
   this.scroll_tracker.$options.parent.applicants.forEach((listItem,indexeach) => {
      if(listItem.applicant != null && listItem.applicant.veda_report != null && listItem.applicant.veda_report.success == true){
          scrollsectionsin.forEach(listItemNew => {
            if(listItemNew.id == "applicant-"+indexeach+"-capture-section-addresses-previous-new")  {
              listItemNew.show = true;
            }
          });
      }
   });  
  },
};
</script>
<style scoped lang="scss">
  @import "../../assets/scss/theme.scss";
</style>
